// extracted by mini-css-extract-plugin
export default {"container":"Background_container__y-QIr","inputGroup":"Background_inputGroup__+xVOQ","label":"Background_label__8vYX6"};